import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { NetworkDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-network-container',
  templateUrl: './network-container.component.html',
  styleUrls: ['./network-container.component.scss']
})
export class NetworkContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  networks$: Observable<NetworkDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("Network");
    this.networks$ = this.gatwayFacade.loadGateway("Network");
    this.networks$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteNetwork(deletedValue: any) {
    this.gatwayFacade.remove("Network", deletedValue);
    // this.store.dispatch(NetworkStoreActions.removeNetwork({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitNetwork(formValue: any) {
    console.log("form value: ", formValue);
    formValue.Networks = formValue.Networks.reverse();
    event.preventDefault();
    const pullData = formValue.Networks;
    //const newPullData = formValue.Networkes;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllNetwork = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllNetwork.push(pullData[i]);
    }
  }

// check if the addAllNetwork array is not empty, then dispatch the data to the store
   if(addAllNetwork.length !== 0) {
    this.gatwayFacade.add('Network', addAllNetwork);
    // this.store.dispatch(NetworkStoreActions.addNetwork({newNetwork: addAllNetwork}));

   }

// dispatch update data to the store
this.gatwayFacade.update('Network', allUpdates, ['id']);
    // this.store.dispatch(NetworkStoreActions.updateNetwork({updateNetwork: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}


